const defaultIconProps = {
  height: "1em",
  width: "1em",
  fontSize: "1em",
  color: "currentColor",
}

export default defaultIconProps
